// extracted by mini-css-extract-plugin
export default {"wrapper":"Banner_wrapper__N2Pd4","banner":"Banner_banner__WrxQH"};